import {
  Button,
  Divider,
  InformationCard,
  Text,
  useIsMobile
} from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  gap: 1rem;

  > img {
    max-width: 200px;
    align-self: center;
  }
`

type InstructionModalProps = {
  onContinue: () => void
  onCancel: () => void
  isOpen: boolean
  title: string
  subtitle: string
  des?: string
  complement?: string
  imageUrl?: string
}

const InstructionModal = ({
  onContinue,
  onCancel,
  isOpen,
  title,
  subtitle,
  des,
  complement,
  imageUrl
}: InstructionModalProps) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()

  return (
    <InformationCard
      isOpen={isOpen}
      title={''}
      close={onCancel}
      hideHeader
      style={{
        width: '100%',
        maxWidth: isMobile ? '90vw' : '600px',
        padding: '2rem 1rem',
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        margin: 0
      }}
    >
      <Container>
        <Text variant='label-required-04'>{title}</Text>
        <Text variant='bordertext-emphasis-05'>{subtitle}</Text>
        <Divider color='gray' style={{ margin: 0, borderTopWidth: '2px' }} />
        {des && <Text variant='label-required-02'>{des}</Text>}
        {complement && <Text variant='label-02'>{complement}</Text>}
        {imageUrl && <img src={imageUrl} alt='Target' />}
        <Button onClick={onContinue}>
          {t('activity-document-photo.instruction-modal.continue')}
        </Button>
        <Button onClick={onCancel} variant='secondary'>
          {t('activity-document-photo.instruction-modal.cancel')}
        </Button>
      </Container>
    </InformationCard>
  )
}

export default InstructionModal
